var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReproveIconRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#EA5455"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1668 38.8333C41.8335 39.4999 41.8335 40.4999 41.1668 41.1666C40.8335 41.4999 40.5002 41.6666 40.0002 41.6666C39.5002 41.6666 39.1668 41.4999 38.8335 41.1666L30.0002 32.3333L21.1668 41.1666C20.8335 41.4999 20.5002 41.6666 20.0002 41.6666C19.5002 41.6666 19.1668 41.4999 18.8335 41.1666C18.1668 40.4999 18.1668 39.4999 18.8335 38.8333L27.6668 29.9999L18.8335 21.1666C18.1668 20.4999 18.1668 19.4999 18.8335 18.8333C19.5002 18.1666 20.5002 18.1666 21.1668 18.8333L30.0002 27.6666L38.8335 18.8333C39.5002 18.1666 40.5002 18.1666 41.1668 18.8333C41.8335 19.4999 41.8335 20.4999 41.1668 21.1666L32.3335 29.9999L41.1668 38.8333Z",
    fill: "#EA5455"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReproveIconRed);
export default __webpack_public_path__ + "static/media/reproveIconRed.826a6b015d9fd6071b9ad6107f8dce7f.svg";
export { ForwardRef as ReactComponent };